import './Developer.css'
function Developer()
{
return(

<div className='box'>
<span>Developed by Nilay Shah  
<meta name="viewport"/>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
<a href="https://www.facebook.com/nilay.shah.92775"><i  className="fa fa-facebook"/></a>
<a href="https://www.linkedin.com/in/nilay-shah-7610551b8/"><i className="fa fa-linkedin"/></a>
<a href="https://www.instagram.com/nilay_shah_nj/"> <i className="fa fa-instagram"/></a>

</span>
</div>
    );
}

export default Developer;